import mixins from "vue-typed-mixins";
import { activeMenuMixin, featureToggleMixin } from "@/mixins";
// async components
const AccountLookUp = () => import(/* webpackChunkName: "AccountLookUp" */ "./_sections/AccountLookUp.vue");
const About = () => import(/* webpackChunkName: "About" */ "./_sections/About.vue");
// const Collaboration = () => import(/* webpackChunkName: "Collaboration" */ "./_sections/Collaboration.vue");
const GovernmentStatement = () => import(
/* webpackChunkName: "GovernmentStatement" */ "./_sections/GovernmentStatement.vue");
const Products = () => import(/* webpackChunkName: "Products" */ "./_sections/Products.vue");
const HowToActivate = () => import(/* webpackChunkName: "HowToActivate" */ "./_sections/HowToActivate.vue");
const Webinar = () => import(/* webpackChunkName: "Webinar" */ "./_sections/Webinar.vue");
// const MateriBelajar = () => import(/* webpackChunkName: "MateriBelajar" */ "./_sections/MateriBelajar.vue");
const Faq = () => import(/* webpackChunkName: "Faq" */ "./_sections/Faq.vue");
const MainMenu = () => import(/* webpackChunkName: "MainMenu" */ "@/components/composite/MainMenu.vue");
export default mixins(activeMenuMixin, featureToggleMixin).extend({
    name: "IndexPage",
    components: {
        AccountLookUp,
        About,
        Products,
        // Collaboration,
        GovernmentStatement,
        HowToActivate,
        Webinar,
        // MateriBelajar,
        Faq,
        MainMenu,
    },
    metaInfo: {
        title: "Akun Pembelajaran | Kemdikbudristek",
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "Akun Pembelajaran merupakan akun elektronik yang diterbitkan oleh Kementerian Pendidikan dan Kebudayaan.",
            },
        ],
    },
    // watch: {
    //   '$route.hash': {
    //     immediate: true,
    //     handler(hash: string) {
    //       this.onActiveTabChange(hash);
    //     },
    //   },
    // },
    mounted() {
        this.onActiveTabChange(this.$route.hash);
    },
    methods: {
        async onActiveTabChange(selector) {
            const hashMap = {
                "#home": 0,
                "#about": 1,
                "#platform": 2,
                "#cara-aktivasi": 3,
                "#webinar": 4,
                "#pernyataan-pemerintah": 5,
                "#faq": 6,
            };
            const index = hashMap[selector];
            this.activeMenu = index;
            this.scrollHash = selector;
            if (!selector)
                return;
            const el = document.querySelector(selector);
            el === null || el === void 0 ? void 0 : el.scrollIntoView({ behavior: "smooth", block: "start" });
        },
    },
});
